<template>
    <div>
        <template v-if="['Super Admin', 'admin', 'internal', 'pelaksana-suban'].includes(cookiesJenisAkun)">
            <div class="card mb-1">
                <div class="card-header px-2 text-uppercase">
                    <h4 class="font-weight-bold text-uppercase">
                        Filters & Pencarian
                    </h4>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-md-3 col-lg-3">
                            <b-form-group label="Tahun Pelaksanaan" label-for="tahunFilter">
                                <b-form-select id="tahunFilter" v-model="formFilter.tahun" :options="dsTahunPelaksanaan"
                                    disabled />
                            </b-form-group>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4">
                            <b-form-group label="Wilayah" label-for="wilayahFilter">
                                <b-overlay :show="isLoadWilayah" variant="light" opacity="0.85" blur="2px" rounded="sm">
                                    <b-form-select id="wilayahFilter" v-model="formFilter.wilayah" :options="dsWilayah"
                                        @change="changeWilayah" />
                                </b-overlay>
                            </b-form-group>
                        </div>
                        <div class="col-12 col-md-5 col-lg-5">
                            <b-form-group label="PD/UKPD/UPB" label-for="kolokFilter">
                                <b-overlay :show="isLoadKolok" variant="light" opacity="0.85" blur="2px" rounded="sm">
                                    <v-select id="kolokFilter" v-model="formFilter.kolok" label="text" :options="dsKolok" />
                                </b-overlay>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="d-flex justify-content-end">
                        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" size="md"
                            @click="submitFilter">
                            <feather-icon icon="SearchIcon" class="mr-1" />Cari
                        </b-button>
                    </div>
                </div>
            </div>
        </template>
        <div ref="formDaftarBmdRef">
            <List :parent-filter="filterValue" :fd="formDatas" @changeStateEvent="handleStateEvent"
                :isButtonClicked="isButtonClicked" />
        </div>
    </div>
</template>
  
<script>
import {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    BFormGroup,
    BFormSelect,
    BSpinner,
} from "bootstrap-vue";
import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import moment from 'moment'
import { generateYears, startYear } from "@/libs/helper";
import skTim from "@/composables/b/skTim";
import master from "@/composables/master";
import vSelect from "vue-select";

import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import { temp } from "@/@core/directives/animations";
import List from "./form/List"

export default {
    setup(props, context) {
        const g = context.root;
        const $route = g.$route;
        const cookiesJenisAkun = ref(g.$cookies.get("jenisAkun"));
        const year = g.$cookies.get("tahun") || moment().format('YYYY');
        const stateEvent = ref('list');
        const formDatas = ref({});
        const formFilter = ref({
            tahun: year,
            versi: null,
            wilayah: ['A', 'D', 'F'].includes(g.$cookies.get("jenisAkun")) ? g.$cookies.get('wilayah') : 'semua',
            kolok: null
        });
        const filterValue = ref({
            tahun: year,
            wilayah: ['A', 'D', 'F'].includes(g.$cookies.get("jenisAkun")) ? g.$cookies.get('wilayah') : 'semua',
            kolok: ['A', 'D', 'F'].includes(g.$cookies.get("jenisAkun")) ? g.$cookies.get('kolok') : 'semua'
        });
        /* Dataset */
        let tempListYear = [{
            text: '--Pilih Salah Satu--',
            value: '',
        }]
        if (g.$cookies.get('listTahun')) {
            const listTahun = JSON.parse(g.$cookies.get('listTahun'))
            tempListYear = [...tempListYear, ...listTahun.map(item => ({ ...item, value: item.tahun_pelaksanaan, text: item.tahun_pelaksanaan }))]
            filterValue.value.tahun = $route.query.tahun || tempListYear[tempListYear.length - 1].value;
            formFilter.value.tahun = $route.query.tahun || tempListYear[tempListYear.length - 1].value;

            const selectedTahun = listTahun.find(entry => entry.tahun_pelaksanaan === filterValue.value.tahun);
            formFilter.value.versi = selectedTahun.tahun_rekon + ' - ' + selectedTahun.kode_rekon;
        } else {
            tempListYear = [...tempListYear, ...generateYears(startYear, year)]
            filterValue.value.tahun = $route.query.tahun || tempListYear[tempListYear.length - 1].value
            formFilter.value.tahun = $route.query.tahun || tempListYear[tempListYear.length - 1].value
        }
        const dsTahunPelaksanaan = ref(tempListYear)
        const isLoadWilayah = ref(false);
        const isLoadKolok = ref(false);
        const dsWilayah = ref([]);
        const getDsWilayah = () => {
            isLoadWilayah.value = true;
            dsWilayah.value = [];
            skTim.getWilayah(g).then(res => {
                if (res.success) {
                    res.rows.unshift({ text: '-- Semua --', value: 'semua' })
                    dsWilayah.value = res.rows;
                }
                isLoadWilayah.value = false;
            }).catch(err => {
                isLoadWilayah.value = false;
                dsWilayah.value = [];
                console.log(err)
            });
        };
        getDsWilayah();

        /* --------- */
        const dsKolok = ref([]);
        const getDsKolok = (searchKolok = "") => {
            isLoadKolok.value = true;
            let params = {
                tahun: formFilter.value.tahun,
                wilayah: formFilter.value.wilayah,
                cari: searchKolok,
            };
            skTim.getKolokDs(g, params).then(res => {
                if (res.success) {
                    res.rows.unshift({ text: '-- Semua --', value: 'semua' })
                    dsKolok.value = res.rows;
                }
                formFilter.value.kolok = (dsKolok.value) ? dsKolok.value?.[0] : 'semua'
                isLoadKolok.value = false;
            }).catch(err => {
                isLoadKolok.value = false;
                console.log(err)
            });

        };
        getDsKolok();

        /* Handler Function */
        const formDaftarBmdRef = ref(null);
        const handleStateEvent = (event) => {
            stateEvent.value = event;
            formDaftarBmdRef.value.scrollIntoView({ behavior: 'smooth' });
        }

        const isButtonClicked = ref(false);
        const submitFilter = () => {
            filterValue.value.tahun = formFilter.value.tahun;
            filterValue.value.wilayah = formFilter.value.wilayah;
            filterValue.value.kolok = (formFilter.value.kolok) ? formFilter.value.kolok.value : 'semua';

            isButtonClicked.value = !isButtonClicked.value;
            handleStateEvent('list')
        };

        const searchPdUpd = async search => {
            getDsKolok(search)
        }

        const changeWilayah = () => {
            formFilter.value.kolok = null
            getDsKolok()
        }

        /* On Mounted */
        /* ------------------------------- */

        /* Download Upload Dokumen SK Tim */
        const loadingCetak = ref(false);
        const cetakDokumenSkTim = () => {
            loadingCetak.value = true;
            setTimeout(() => {
                loadingCetak.value = false;
            }, 2000);
        }
        return {
            isLoadWilayah,
            isLoadKolok,
            formFilter,
            filterValue,
            dsTahunPelaksanaan,
            dsWilayah,
            dsKolok,
            submitFilter,
            searchPdUpd,
            changeWilayah,
            /////////////////

            formDaftarBmdRef,
            cookiesJenisAkun,

            stateEvent,
            formDatas,
            handleStateEvent,

            loadingCetak,
            cetakDokumenSkTim,
            isButtonClicked
        };
    },
    components: {
        BRow,
        BCol,
        BCard,
        BCardHeader,
        BCardBody,
        BButton,
        BFormGroup,
        BFormSelect,
        BButton,
        BSpinner,
        vSelect,
        ValidationProvider,
        ValidationObserver,
        List
    },
    data() {
        return {
            required
        };
    },

    methods: {

    },
    directives: {
        Ripple,
    },
    props: {
        page: String,
    },
};
</script>
<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>